import React from 'react'
import { ThemeProvider } from '@material-ui/core'
import theme from '../../theme'
import ClaimantContext from '../../context/col'
import { RouterApp } from './RouterApp'
import VocabularyContext from '../../context/vocabulary'
import TreatmentExpensesProvider from '../../context/TreatmentExpensesContext'
import { Ga4ContextProvider } from '../../context/Ga4Context'

const App = () => (
  <ThemeProvider theme={theme}>
    <ClaimantContext>
      <VocabularyContext>
        <Ga4ContextProvider >
          <TreatmentExpensesProvider>
            <RouterApp />
          </TreatmentExpensesProvider>
        </Ga4ContextProvider>
      </VocabularyContext>
    </ClaimantContext>
  </ThemeProvider>
)

export default App
